import { z } from 'zod';

export const categorySchema = z.object({
  name: z.object({
    english: z.string().min(1, 'English name is required').max(200, 'Name cannot exceed 200 characters').trim(),
    hindi: z.string().max(200, 'Name cannot exceed 200 characters').trim().optional(),
    marwari: z.string().max(200, 'Name cannot exceed 200 characters').trim().optional(),
  }),
  slug: z.string().toLowerCase().trim().optional(),
  description: z.object({
    english: z.string().min(1, 'English description is required').trim(),
    hindi: z.string().trim().optional(),
    marwari: z.string().trim().optional(),
  }),
  parentCategory: z
    .string()
    .regex(/^[0-9a-fA-F]{24}$/, 'Invalid ObjectId format')
    .optional()
    .nullable(),
  icon: z.string().trim().optional().or(z.literal('')),
  image: z.string().trim().optional().or(z.literal('')),
  color: z
    .string()
    .min(1, 'Color is required')
    .regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Color must be a valid hex color code')
    .trim(),
  isActive: z.boolean().default(true).optional(),
  isPopular: z.boolean().default(false).optional(),
  isFeatured: z.boolean().default(false).optional(),
  seo: z.object({
    metaTitle: z.string().min(1, 'Meta title is required').max(60, 'Meta title should not exceed 60 characters').trim(),
    metaDescription: z
      .string()
      .min(1, 'Meta description is required')
      .max(160, 'Meta description should not exceed 160 characters')
      .trim(),
    keywords: z.array(z.string().trim()).optional(), // still optional
  }),
});
